import React, { useState, useEffect } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, IconButton, Button, Dialog, DialogActions,
  DialogContent,
  DialogTitle, Modal, Select, MenuItem, InputLabel, FormControl, Grid, Collapse, Typography, Box, TablePagination, TextField,
} from '@mui/material';
import axios from '../../../Axiosinstance';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Header from '../../Component/Header';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import NewCompany from '../Company/Newcompany';
import { ToastContainer } from 'react-toastify';
import { KeyboardArrowDown, KeyboardArrowUp, Edit } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import ClearIcon from '@mui/icons-material/Clear';
import CloseIcon from '@mui/icons-material/Close';



const AllCompany = () => {
  const [companies, setCompanies] = useState([]);
  const [openRows, setOpenRows] = useState({});
  const [searchTerm, setSearchTerm] = useState(""); // Search term state
  const [openCompanyModal, setOpenCompanyModal] = useState(false); // Modal state for editing company
  const [openContactModal, setOpenContactModal] = useState(false); // Modal state for editing contact
  const [selectedCompany, setSelectedCompany] = useState(null); // Selected company for editing
  const [selectedContact, setSelectedContact] = useState({
    contactNumber: '',
    contactPerson: '',
    contactPhoneNumbers: [],
    contactEmails: [],
    contactTelephoneNumbers: [],
    contactDesignation: '',
    contactEmail: '',
    paymentTypes: '',
    discountFee: '',
    dob: '',
    nationality: '',
    status: '',
    soa: '',
    gender: '',
    id:''
  });



  const handleContactChange = (e) => {
    const { name, value } = e.target;
    setSelectedContact((prevState) => ({
      ...prevState,
      [name]: value, // Dynamically update based on field name
    }));
  };


  const handleContactSubmit = (id) => {
    
    axios
      .put(`/wsq/companies/${id}/editCompanyContact`, selectedContact)
      .then((response) => {
        setCompanies((prevCompanies) =>
          prevCompanies.map((company) =>
            company.id === selectedCompany.id
              ? {
                ...company,
                contacts: company.contacts.map((contact) =>
                  contact.contactNumber === selectedContact.contactNumber
                    ? { ...response.data } // Update with the latest data
                    : contact
                ),
              }
              : company
          )
        );
        fetchCompanies() 
        handleCloseContactModal();
      })
      .catch((error) => console.error("Error updating contact:", error));
  };

  const fetchCompanies = () => {
    axios
      .get("/wsq/companies/getAllCompaniesWithContacts")
      .then((response) => setCompanies(response.data))
      .catch((error) => console.error("Error fetching companies:", error));
  };


  // Fetch data from the API
  useEffect(() => {
    fetchCompanies()  
  }, []);

  // Toggle row expansion for contacts
  const handleRowClick = (id) => {
    setOpenRows((prevOpenRows) => ({
      ...prevOpenRows,
      [id]: !prevOpenRows[id],
    }));
  };


  // Filter companies based on search term
  const filteredCompanies = companies.filter((company) =>
    company.uen?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5); // Default rows per page
  // Handle pagination changes
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page
  };

  const handleOpenCompanyModal = (company) => {
    setSelectedCompany(company);
    setOpenCompanyModal(true);
  };

  const handleCloseModals = () => {
    setOpenCompanyModal(false);
    setOpenContactModal(false);
    setSelectedCompany(null);
    setSelectedContact({
      contactNumber: '',
      contactPerson: '',
      contactPhoneNumbers: [],
      contactEmails: [],
      contactTelephoneNumbers: [],
      contactDesignation: '',
      contactEmail: '',
      paymentTypes: '',
      discountFee: '',
      dob: '',
      nationality: ''
    });
  };

  const handleEditSubmit = () => {
    axios
      .put(`/wsq/companies/${selectedCompany.id}/editCompany`, selectedCompany)
      .then((response) => {
        setCompanies((prevCompanies) =>
          prevCompanies.map((company) =>
            company.id === selectedCompany.id ? response.data : company
          )
        );
        handleCloseModals();
      })
      .catch((error) => console.error("Error updating company:", error));
  };

  const handleOpenContactModal = (company, contact) => {
    setSelectedCompany(company);
    setSelectedContact({
      contactNumber: contact?.contactNumber || '',
      contactPerson: contact?.contactPerson || '',
      contactPhoneNumbers: contact?.contactPhoneNumbers || [],
      contactEmails: contact?.contactEmails || [],
      contactTelephoneNumbers: contact?.contactTelephoneNumbers || [],
      contactDesignation: contact?.contactDesignation || '',
      contactEmail: contact?.contactEmail || '',
      paymentTypes: contact?.paymentTypes || '',
      discountFee: contact?.discountFee || '',
      dob: contact?.dob || '',
      nationality: contact?.nationality || '',
      status: contact?.status || '',
      soa: contact?.soa || '',
      gender: contact?.gender || '',
      id:contact?.id ||''
    });
    setOpenContactModal(true);
   
  };


  const handleCloseContactModal = () => {
    setOpenContactModal(false);
    setSelectedContact({
      contactNumber: '',
      contactPerson: '',
      contactPhoneNumbers: [],
      contactEmails: [],
      contactTelephoneNumbers: [],
      contactDesignation: '',
      contactEmail: '',
      paymentTypes: '',
      discountFee: '',
      dob: '',
      nationality: '',
      status: '',
      soa: '',
      gender: ''
    });
  };

  const handleArrayChange = (e, index, fieldName) => {
    const updatedArray = [...selectedContact[fieldName]];
    updatedArray[index] = e.target.value;

    setSelectedContact((prevState) => ({
      ...prevState,
      [fieldName]: updatedArray,
    }));
  };


  const handleAddField = (field) => {
    const updatedArray = [...selectedContact[field], ''];
    setSelectedContact({ ...selectedContact, [field]: updatedArray });
  };

  const handleRemoveField = (index, field) => {
    const updatedArray = selectedContact[field].filter((_, i) => i !== index);
    setSelectedContact({ ...selectedContact, [field]: updatedArray });
  };


  return (
    <div>
    <Box p={2}>
  <Box display="flex" alignItems="center" gap={2}>
    <TextField
      label="Search by UEN"
      variant="outlined"
      fullWidth
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      placeholder="Enter UEN to search"
      InputProps={{
        endAdornment: (
          <IconButton
            onClick={() => setSearchTerm('')}
            edge="end"
            aria-label="clear search"
          >
            <ClearIcon />
          </IconButton>
        ),
      }}
    />
  </Box>
</Box>

<TableContainer component={Paper}>
  <Table>
    <TableHead >
      <TableRow >
        <TableCell />
        <TableCell>Company ID</TableCell>
        <TableCell >Company Name</TableCell>
        <TableCell>UEN /REG NO</TableCell>
        <TableCell>Mobile</TableCell>
        <TableCell>Telephone</TableCell>
        <TableCell>Email</TableCell>
        <TableCell>Address</TableCell>
        <TableCell>Postal Code</TableCell>


       
        <TableCell>Actions</TableCell>
  
        <TableCell>Industry</TableCell>
        <TableCell>SSIC</TableCell>
        <TableCell>Status</TableCell>
        <TableCell>SOA</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {filteredCompanies
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((company) => (
          <React.Fragment key={company.id}>
            {/* Main Row for Company */}
            <TableRow hover>
              <TableCell>
                <IconButton onClick={() => handleRowClick(company.id)}>
                  {openRows[company.id] ? (
                    <KeyboardArrowUp />
                  ) : (
                    <KeyboardArrowDown />
                  )}
                </IconButton>
              </TableCell>
              <TableCell>{company.id}</TableCell>
              <TableCell>{company.clientCompanyName}</TableCell>
              <TableCell>{company.uen}</TableCell>
              <TableCell>{company.companyPhoneNumbers.join(", ") || "N/A"}</TableCell>
              <TableCell>{company.companyTelephoneNumbers.join(", ") || "N/A"}</TableCell>
              <TableCell>{company.companyEmails.join(", ") || "N/A"}</TableCell>

              <TableCell>{company.companyAddress}</TableCell>
              <TableCell>{company.postalCode || "N/A"}</TableCell>
              
              <TableCell>
                <IconButton onClick={() => handleOpenCompanyModal(company)}>
                  <Edit />
                </IconButton>
              </TableCell>
    
              <TableCell>{company.industry || "Not Provided"}</TableCell>
              <TableCell>{company.ssic || "Not Provided"}</TableCell>
              <TableCell>{company.status}</TableCell>
              <TableCell>{company.soa || "Not Provided"}</TableCell>
            </TableRow>

            {/* Collapsible Row for Contacts */}
            <TableRow>
              <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
                <Collapse in={openRows[company.id]} timeout="auto" unmountOnExit>
                  <Box margin={1}>
                    <Table size="small" aria-label="contacts">
                      <TableHead>
                        <TableRow>
                          <TableCell>S.no</TableCell>
                          <TableCell>Name</TableCell>
                          <TableCell>Designation</TableCell>
                          <TableCell>Mobile</TableCell>
                          <TableCell>Telephone</TableCell>
                          <TableCell>Email</TableCell>
                          <TableCell>Action</TableCell>
                          <TableCell>Gender</TableCell>
                          <TableCell>DOB</TableCell>
                         
                          <TableCell>Nationality</TableCell>
                          <TableCell>Sales Person</TableCell>

                          <TableCell>Payment</TableCell>
                          <TableCell>Status</TableCell>
                          <TableCell>SOA</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {company.contacts.map((contact, index) => (
                          <TableRow key={index}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{contact.contactPerson}</TableCell>
                            <TableCell>{contact.contactDesignation || "N/A"}</TableCell>

                            <TableCell>{contact.contactPhoneNumbers.join(", ") || "N/A"}</TableCell>
                            <TableCell>{contact.contactTelephoneNumbers.join(", ") || "N/A"}</TableCell>

                            <TableCell>{contact.contactEmails.join(", ") || "N/A"}</TableCell>
                            <TableCell>
                              <IconButton onClick={() => handleOpenContactModal(company, contact)}>
                                <Edit />
                              </IconButton>
                            </TableCell>
                            <TableCell>{contact.gender || "Not Provided"}</TableCell>
                            <TableCell>{contact.dob || "Not Provided"}</TableCell>
                            <TableCell>{contact.nationality || "Not Provided"}</TableCell>
                            <TableCell>{contact.salespersonName || "Not Assign"}</TableCell>

                            <TableCell>{contact.paymentType || "Not Provided"}</TableCell>

                            <TableCell>{contact.status || "Not Provided"}</TableCell>
                            <TableCell>{contact.soa || "Not Provided"}</TableCell>

                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Box>
                </Collapse>
              </TableCell>
            </TableRow>
          </React.Fragment>
        ))}
    </TableBody>
  </Table>
  <TablePagination
    component="div"
    count={companies.length}
    page={page}
    onPageChange={handleChangePage}
    rowsPerPage={rowsPerPage}
    onRowsPerPageChange={handleChangeRowsPerPage}
    rowsPerPageOptions={[5, 10, 25]}
  />
</TableContainer>



      {/* company Modal */}
      <Dialog open={openCompanyModal} onClose={handleCloseModals} maxWidth="md" fullWidth>
        <DialogTitle>Edit Company
        <IconButton
      edge="end"
      color="inherit"
      onClick={handleCloseModals}
      aria-label="close"
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
        color: (theme) => theme.palette.grey[500],
      }}
    >
      <CloseIcon />
    </IconButton>
        </DialogTitle>
        <DialogContent>
          <form>
            <Grid container spacing={2}>
              {/* Company Name */}
              <Grid item xs={12} sm={6}>
                <div className="form-group">
                  <label>Company Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={selectedCompany?.clientCompanyName || ""}
                    onChange={(e) =>
                      setSelectedCompany({
                        ...selectedCompany,
                        clientCompanyName: e.target.value,
                      })
                    }
                  />
                </div>
              </Grid>

              {/* UEN */}
              <Grid item xs={12} sm={6}>
                <div className="form-group">
                  <label>UEN</label>
                  <input
                    type="text"
                    className="form-control"
                    value={selectedCompany?.uen || ""}
                    onChange={(e) =>
                      setSelectedCompany({
                        ...selectedCompany,
                        uen: e.target.value,
                      })
                    }
                  />
                </div>
              </Grid>

              {/* Company Address and Postal Code */}
              <Grid item xs={12} sm={6}>
                <div className="form-group">
                  <label>Company Address</label>
                  <input
                    type="text"
                    className="form-control"
                    value={selectedCompany?.companyAddress || ""}
                    onChange={(e) =>
                      setSelectedCompany({
                        ...selectedCompany,
                        companyAddress: e.target.value,
                      })
                    }
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className="form-group">
                  <label>Postal Code</label>
                  <input
                    type="text"
                    className="form-control"
                    value={selectedCompany?.postalCode || ""}
                    onChange={(e) =>
                      setSelectedCompany({
                        ...selectedCompany,
                        postalCode: e.target.value,
                      })
                    }
                  />
                </div>
              </Grid>

              {/* Billing Address */}
              <Grid item xs={12}>
                <div className="form-group">
                  <label>Billing Address</label>
                  <input
                    type="text"
                    className="form-control"
                    value={selectedCompany?.billingAddress || ""}
                    onChange={(e) =>
                      setSelectedCompany({
                        ...selectedCompany,
                        billingAddress: e.target.value,
                      })
                    }
                  />
                </div>
              </Grid>

              {/* Emails, Phones, and Telephones Section */}
              <Grid item xs={12}>
                <div className="form-group">
                  <label>Company Emails</label>
                  {selectedCompany?.companyEmails?.map((email, index) => (
                    <div key={index} className="d-flex align-items-center mb-2">
                      <input
                        type="email"
                        className="form-control"
                        value={email}
                        onChange={(e) => {
                          const updatedEmails = [...selectedCompany.companyEmails];
                          updatedEmails[index] = e.target.value;
                          setSelectedCompany({ ...selectedCompany, companyEmails: updatedEmails });
                        }}
                      />
                      {index !== selectedCompany.companyEmails.length - 1 && (
                        <IconButton
                          color="secondary"
                          onClick={() => {
                            const updatedEmails = [...selectedCompany.companyEmails];
                            updatedEmails.splice(index, 1);
                            setSelectedCompany({ ...selectedCompany, companyEmails: updatedEmails });
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      )}
                    </div>
                  ))}
                  <IconButton
                    type="button"
                    color="primary"
                    onClick={() =>
                      setSelectedCompany({
                        ...selectedCompany,
                        companyEmails: [...(selectedCompany.companyEmails || []), ""],
                      })
                    }
                  >
                    <AddIcon />
                  </IconButton>
                </div>

                <div className="form-group">
                  <label>Company Phone Numbers</label>
                  {selectedCompany?.companyPhoneNumbers?.map((phone, index) => (
                    <div key={index} className="d-flex align-items-center mb-2">
                      <input
                        type="text"
                        className="form-control"
                        value={phone}
                        onChange={(e) => {
                          const updatedPhones = [...selectedCompany.companyPhoneNumbers];
                          updatedPhones[index] = e.target.value;
                          setSelectedCompany({ ...selectedCompany, companyPhoneNumbers: updatedPhones });
                        }}
                      />
                      {index !== selectedCompany.companyPhoneNumbers.length - 1 && (
                        <IconButton
                          color="secondary"
                          onClick={() => {
                            const updatedPhones = [...selectedCompany.companyPhoneNumbers];
                            updatedPhones.splice(index, 1);
                            setSelectedCompany({ ...selectedCompany, companyPhoneNumbers: updatedPhones });
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      )}
                    </div>
                  ))}
                  <IconButton
                    type="button"
                    color="primary"
                    onClick={() =>
                      setSelectedCompany({
                        ...selectedCompany,
                        companyPhoneNumbers: [...(selectedCompany.companyPhoneNumbers || []), ""],
                      })
                    }
                  >
                    <AddIcon />
                  </IconButton>
                </div>

                <div className="form-group">
                  <label>Company Telephone Numbers</label>
                  {selectedCompany?.companyTelephoneNumbers?.map((telephone, index) => (
                    <div key={index} className="d-flex align-items-center mb-2">
                      <input
                        type="text"
                        className="form-control"
                        value={telephone}
                        onChange={(e) => {
                          const updatedTelephones = [...selectedCompany.companyTelephoneNumbers];
                          updatedTelephones[index] = e.target.value;
                          setSelectedCompany({ ...selectedCompany, companyTelephoneNumbers: updatedTelephones });
                        }}
                      />
                      {index !== selectedCompany.companyTelephoneNumbers.length - 1 && (
                        <IconButton
                          color="secondary"
                          onClick={() => {
                            const updatedTelephones = [...selectedCompany.companyTelephoneNumbers];
                            updatedTelephones.splice(index, 1);
                            setSelectedCompany({ ...selectedCompany, companyTelephoneNumbers: updatedTelephones });
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      )}
                    </div>
                  ))}
                  <IconButton
                    type="button"
                    color="primary"
                    onClick={() =>
                      setSelectedCompany({
                        ...selectedCompany,
                        companyTelephoneNumbers: [...(selectedCompany.companyTelephoneNumbers || []), ""],
                      })
                    }
                  >
                    <AddIcon />
                  </IconButton>
                </div>
              </Grid>

              {/* Industry and SSIC */}
              <Grid item xs={12} sm={6}>
                <div className="form-group">
                  <label>Industry</label>
                  <input
                    type="text"
                    className="form-control"
                    value={selectedCompany?.industry || ""}
                    onChange={(e) =>
                      setSelectedCompany({
                        ...selectedCompany,
                        industry: e.target.value,
                      })
                    }
                  />
                </div>
              </Grid>

              <Grid item xs={12} sm={6}>
                <div className="form-group">
                  <label>SSIC</label>
                  <input
                    type="text"
                    className="form-control"
                    value={selectedCompany?.ssic || ""}
                    onChange={(e) =>
                      setSelectedCompany({
                        ...selectedCompany,
                        ssic: e.target.value,
                      })
                    }
                  />
                </div>
              </Grid>

              <Grid item xs={12} sm={6}>
                <div className="form-group">
                  <label>Status</label>
                  <select
                    className="form-control"
                    value={selectedCompany?.status || ""}
                    onChange={(e) =>
                      setSelectedCompany({
                        ...selectedCompany,
                        status: e.target.value,
                      })
                    }
                  >
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div>
              </Grid>



              <Grid item xs={12} sm={6}>
                <div className="form-group">
                  <label>SOA</label>
                  <input
                    type="text"
                    className="form-control"
                    value={selectedCompany?.soa || ""}
                    onChange={(e) =>
                      setSelectedCompany({
                        ...selectedCompany,
                        soa: e.target.value,
                      })
                    }
                  />
                </div>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        {/* Modal Footer */}
        <DialogActions>
           <button type="button" className="btn btn-secondary" onClick={handleCloseModals}>
      Cancel
    </button>
          <button type="button" className="btn btn-primary" onClick={handleEditSubmit}>
            Save Changes
          </button>
        </DialogActions>
      </Dialog>

      {/* contact Modal */}
      <Dialog open={openContactModal} onClose={handleCloseContactModal}>
        <DialogTitle>Edit Contact</DialogTitle>
        <DialogContent>
          <TextField
            label="Contact Person"
            value={selectedContact.contactPerson}
            name="contactPerson"
            onChange={handleContactChange}
            fullWidth
          />
{selectedContact.id}id
          {/* Contact Phone Numbers */}
          <div>
            <label>Contact Phone Numbers</label>
            {selectedContact.contactPhoneNumbers.map((phone, index) => (
              <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                <TextField
                  value={phone}
                  onChange={(e) => handleArrayChange(e, index, 'contactPhoneNumbers')}
                  fullWidth
                  margin="dense"
                />
                <IconButton
                  onClick={() => handleRemoveField(index, 'contactPhoneNumbers')}
                  color="secondary"
                >
                  <DeleteIcon />
                </IconButton>
              </div>
            ))}
            <Button
              onClick={() => handleAddField('contactPhoneNumbers')}
              startIcon={<AddIcon />}
              color="primary"
            >
              Add Phone Number
            </Button>
          </div>

          {/* Contact Emails */}
          <div>
            <label>Contact Emails</label>
            {selectedContact.contactEmails.map((email, index) => (
              <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                <TextField
                  value={email}
                  onChange={(e) => handleArrayChange(e, index, 'contactEmails')}
                  fullWidth
                  margin="dense"
                />
                <IconButton
                  onClick={() => handleRemoveField(index, 'contactEmails')}
                  color="secondary"
                >
                  <DeleteIcon />
                </IconButton>
              </div>
            ))}
            <Button
              onClick={() => handleAddField('contactEmails')}
              startIcon={<AddIcon />}
              color="primary"
            >
              Add Email
            </Button>
          </div>

          {/* Other Fields */}
          <TextField
            label="Designation"
            value={selectedContact.contactDesignation}
            name="contactDesignation"
            onChange={handleContactChange}
            fullWidth
            margin="normal"
          />

          {/* <FormControl fullWidth margin="normal">
            <InputLabel>Payment Types</InputLabel>
            <Select
              value={selectedContact.paymentTypes}
              name="paymentTypes"
              onChange={handleContactChange}
            >
              <MenuItem value="COD">COD</MenuItem>
              <MenuItem value="7 days">7 Days</MenuItem>
              <MenuItem value="15 days">15 Days</MenuItem>
              <MenuItem value="30 days">30 Days</MenuItem>
              <MenuItem value="GIRO">GIRO</MenuItem>
            </Select>
          </FormControl> */}

          <TextField
            label="Date of Birth"
            type="date"
            value={selectedContact.dob}
            name="dob"
            onChange={handleContactChange}
            fullWidth
            InputLabelProps={{ shrink: true }}
            margin="normal" 
          />


          <FormControl fullWidth margin="normal">
            <InputLabel>Status</InputLabel>
            <Select
              value={selectedContact.status}
              name="status"
              onChange={handleContactChange}
            >
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="inactive">Inactive</MenuItem>
            </Select>
          </FormControl>

          <TextField
            label="SOA"
            value={selectedContact.soa}
            name="soa"
            onChange={handleContactChange}
            fullWidth
          />

          <FormControl fullWidth margin="normal">
            <InputLabel>Gender</InputLabel>
            <Select
              value={selectedContact.gender}
              name="gender"
              onChange={handleContactChange}
            >
              <MenuItem value="male">Male</MenuItem>
              <MenuItem value="female">Female</MenuItem>
              <MenuItem value="other">Other</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth margin="normal">
            <InputLabel>Nationality</InputLabel>
            <Select
              value={selectedContact.nationality}
              name="nationality"
              onChange={handleContactChange}
            >
              <MenuItem value="singaporian">Singaporean</MenuItem>
              <MenuItem value="malaiya">Malaysian</MenuItem>
              <MenuItem value="indian">Indian</MenuItem>
              <MenuItem value="bangalesh">Bangladeshi</MenuItem>
            </Select>
          </FormControl>

        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseContactModal} color="primary">
            Cancel
          </Button>
          <Button onClick={() => handleContactSubmit(selectedContact.id)} color="primary">
  Submit
</Button>

        </DialogActions>
      </Dialog>


    </div>
  );
};



const Company = () => {
  const [tabValue, setTabValue] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };




  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <Header />
      <Box mt={4} display="flex" justifyContent="center">
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant="fullWidth"
          sx={{
            borderRadius: 10,
            display: isMobile ? "block" : "flex",
            justifyContent: isMobile ? "flex-start" : "center",
            alignItems: isMobile ? "stretch" : "center",
            "& button": {
              display: "flex",
              justifyContent: "center",
              width: isMobile ? "100%" : "auto",
              padding: isMobile ? "12px" : "8px 16px",
            },
            "& button:hover": {
              backgroundColor: "#eee",
            },
            "& button:active": {
              backgroundColor: "#ddd",
            },
            "& button.Mui-selected": {
              backgroundColor: "#007bff",
              color: "#fff",
            },
            "& .MuiTabs-indicator": {
              display: "none",
            },
          }}
        >
          <Tab
            label="All Company"
            sx={{
              minWidth: isMobile ? "100%" : "600px",
              marginBottom: isMobile ? "8px" : "0",
            }}
          />
          <Tab
            label="Company Form"
            sx={{
              minWidth: isMobile ? "100%" : "600px",
              marginBottom: isMobile ? "8px" : "0",
            }}
          />
        </Tabs>
      </Box>
      <Box mt={2}>
        {tabValue === 0 && <AllCompany />}
        {tabValue === 1 && <NewCompany onCourseCreated={() => handleTabChange(null, 0)} />
        }

      </Box>
      <ToastContainer />
    </div>
  );
};


export default Company;
